'use client';

import React from 'react';
import styled from 'styled-components';

export type URLStatusBadgeStatus = 'Active' | 'Running' | 'Inactive';

export interface URLStatusBadgeProps {
  status: URLStatusBadgeStatus;
  children?: React.ReactNode;
  isInline?: boolean;
  className?: string;
}

const colorMap = {
  Active: '#009951',
  Running: '#FB6F2A',
  Inactive: '#EC221F',
};

const StyledInlineURLStatusBadge = styled.span<{ $status: URLStatusBadgeStatus }>`
  color: ${({ $status }) => colorMap[$status]};
`;

const StyledURLStatusBadge = styled.span<{ $status: URLStatusBadgeStatus }>`
  display: inline-flex;
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  white-space: nowrap;
  text-transform: uppercase;
  color: ${({ $status }) => colorMap[$status]};
`;

export const URLStatusBadge: React.FC<URLStatusBadgeProps> = ({ 
  status, 
  children,
  className ,isInline
}) => {
  return (
    isInline ? (
      <StyledInlineURLStatusBadge $status={status} className={className}>
        {children}
      </StyledInlineURLStatusBadge>
    ) : (
      <StyledURLStatusBadge $status={status} className={className}>
      {children}
    </StyledURLStatusBadge>
  ))
};

export default URLStatusBadge;

